import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

const renderField = ({input, label, tooltip, placeholder, dataField, readOnly, inputGroupText, confirmed, disabled, type, meta: {touched, error}}) => (
	<div>
		<span className="small">{label}</span>
		<div className={(inputGroupText||tooltip||confirmed) ? "input-group" : ""}>
			<input {...input} readOnly={readOnly} data-field={dataField} placeholder={placeholder} type={type} className={"form-control" + ((touched && error) ? " invalid": "")} disabled={disabled}/>
			{inputGroupText&&<div className="input-group-append">
				<span className="input-group-text" id={inputGroupText}>{inputGroupText}</span>
			</div>}
			{confirmed==='true'&&<div className="input-group-append">
				<span className="input-group-text"><FontAwesomeIcon icon={faCheck} color="#009900"/></span>
			</div>}
			{confirmed==='false'&&<div className="input-group-append">
				<span className="input-group-text"><FontAwesomeIcon icon={faTimes} color="#FF3333"/></span>
			</div>}
			<span className="small tooltip-text">{tooltip}</span>
			{touched && error && (error!=="Required") &&<div className="error">{error}</div>}
		</div>
	</div>
)

export default renderField


// WEBPACK FOOTER //
// ./src/components/fields/renderField.js